import { faIdCard } from "@fortawesome/duotone-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FC } from "react";

const DataGridPersonnelRoleIconCell: FC = () => <FontAwesomeIcon icon={faIdCard} />;

export default DataGridPersonnelRoleIconCell;
